import React__default from 'react';

const width = 20;
const height = 20;
const IconAdd = ({ fill = "black", size = 1 }) => {
    return (React__default.createElement("svg", { width: size * width, height: size * height, fill: "none", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
        React__default.createElement("path", { d: "M9 9V5H11V9H15V11H11V15H9V11H5V9H9Z", fill: fill }),
        React__default.createElement("path", { d: "M0 10C0 4.47715 4.47715 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM2 10C2 14.4183 5.58172 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10Z", fill: fill, fillRule: "evenodd" })));
};

export { IconAdd as default };
//# sourceMappingURL=IconAdd.js.map
